// extracted by mini-css-extract-plugin
export default {"maxHeight":"AttachmentsTabPanel_maxHeight__PBDGB"};